import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { LegacyCard, Spinner, Text } from "@shopify/polaris";
import { useEffect, useState } from "react";
import "leaflet/dist/leaflet.css";
import supabase from "../../supabase-client";
import { formatDate, formatFriendlyDate } from "../../utility/funcs";

// Fix Leaflet default marker path issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function CarMap({ vin }) {
  const [coords, setCoords] = useState(null);
  const hasGps = !!vin;

  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await supabase.functions.invoke(
        "get_nexofleet_gps",
        { body: { vin } },
      );

      if (error) {
        console.error("Nexofleet GPS error:", error);
        return;
      }

      if (data) {
        setCoords({
          name: data.name,
          lat: Number(data.lat),
          lon: Number(data.lon),
          odometer: data.odometer,
          last_update: data.last_update,
        });
      }
    };

    if (hasGps) fetchData();
  }, [vin, hasGps]);

  function tiempoTranscurrido(fechaUTCString) {
    if (!fechaUTCString) return "sin datos";
    const fechaUTC = new Date(fechaUTCString);

    // Hora actual local (Monterrey)
    const ahora = new Date();

    // Diferencia en segundos
    const diff = Math.floor((ahora - fechaUTC) / 1000);

    if (diff < 60) return `hace ${diff} segundos`;

    const minutos = Math.floor(diff / 60);
    if (minutos < 60) return `hace ${minutos} minutos`;

    const horas = Math.floor(minutos / 60);
    if (horas < 24) return `hace ${horas} horas`;

    const dias = Math.floor(horas / 24);
    if (dias < 60) return `hace ${dias} días`;

    return `hace ${dias} días`;
  }

  const content = () => {
    if (!hasGps || !coords)
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "80px",
          }}
        >
          {!hasGps ? (
            <Text tone="subdued">El auto no tiene GPS.</Text>
          ) : (
            <Spinner size="small" />
          )}
        </div>
      );

    return (
      <div style={{ width: "100%", height: "250px" }}>
        <MapContainer
          center={[coords.lat, coords.lon]}
          zoom={15}
          style={{ height: 250, width: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution={`${tiempoTranscurrido(coords.last_update)}`}
            className="leaflet-map-container"
          />
          <Marker position={[coords.lat, coords.lon]} />
        </MapContainer>
      </div>
    );
  };

  return (
    <div>
      <LegacyCard>{content()}</LegacyCard>
    </div>
  );
}

export default CarMap;
